export type PaymentGatewaySettingsKind = 'redirect-ipg' | 'internal' | 'none';

export type PaymentGatewayFamily = 'parsian-pec' | string;

export interface PaymentProviderUiProfile {
  providerKey: string;
  settingsKind: PaymentGatewaySettingsKind;
  gatewayFamily?: PaymentGatewayFamily;
  /** When false, callback secret is optional on first enable (server may generate). */
  requiresCallbackSecretOnEnable: boolean;
}

const DEFAULT_PROFILE: PaymentProviderUiProfile = {
  providerKey: '',
  settingsKind: 'none',
  requiresCallbackSecretOnEnable: true
};

const PROFILES: Record<string, PaymentProviderUiProfile> = {
  parsian: {
    providerKey: 'parsian',
    settingsKind: 'redirect-ipg',
    gatewayFamily: 'parsian-pec',
    requiresCallbackSecretOnEnable: false
  },
  wallet: {
    providerKey: 'wallet',
    settingsKind: 'internal',
    requiresCallbackSecretOnEnable: true
  },
  installment: {
    providerKey: 'installment',
    settingsKind: 'internal',
    requiresCallbackSecretOnEnable: true
  }
};

export function getPaymentProviderUiProfile(providerKey: string): PaymentProviderUiProfile {
  const key = providerKey.trim().toLowerCase();
  return PROFILES[key] ?? { ...DEFAULT_PROFILE, providerKey: key };
}
